const Platforms = Object.freeze([
    {
        id: 'gcp',
        capitalizedId: 'GCP',
        name: 'Google Cloud Platform',
        shortName: 'GCP',
    },
    {
        id: 'alibaba',
        capitalizedId: 'Alibaba',
        name: 'Alibaba Cloud',
        shortName: 'Alibaba Cloud',
    },
    {
        id: 'tencent',
        capitalizedId: 'Tencent',
        name: 'Tencent Cloud',
        shortName: 'Tencent Cloud',
    },
    {
        id: 'akamai',
        capitalizedId: 'Akamai',
        name: 'Akamai',
        shortName: 'Akamai',
    },
    {
        id: 'workspace',
        capitalizedId: 'Workspace',
        name: 'Google Workspace',
        shortName: 'Google Workspace',
    },
    {
        id: 'azure',
        capitalizedId: 'Azure',
        name: 'Microsoft Azure',
        shortName: 'Azure',
    },
    {
        id: 'oci',
        capitalizedId: 'OCI',
        name: 'Oracle Cloud Infrastructure',
        shortName: 'OCI',
    },
    {
        id: 'aws',
        capitalizedId: 'AWS',
        name: 'Amazon Web Services',
        shortName: 'AWS',
    },
]);

Platforms.forEach(platform => Object.freeze(platform));

const PlatformID = Object.freeze(Platforms.reduce((obj, platform) => {
    obj[platform.capitalizedId] = platform.id;
    return obj;
}, {}));

const platformMap = Platforms.reduce((obj, platform) => {
    obj[platform.id] = platform;
    return obj;
}, {});

function getPlatform(id) {
    return platformMap[(id || '').toLowerCase()];
}

module.exports = {
    PlatformID,
    Platforms,

    getPlatform,
};
